import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ProfileComponent } from "./profile.component";
import { PersonalDetailsComponent } from "./components/personal-details/personal-details.component";
import { ContactDetailsComponent } from "./components/contact-details/contact-details.component";
import { EducationDetailsComponent } from "./components/education-details/education-details.component";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PartialsModule } from "../../partials/partials.module";
import {
	MatSelectModule,
	MatRadioModule,
	MatCheckboxModule,
	MatIconModule,
	MatDatepickerModule,
	MatProgressSpinnerModule,
	MatInputModule,
	MatBottomSheetRef,
	MAT_BOTTOM_SHEET_DATA,
	MatTreeModule,
	MatMenuModule,
	MatExpansionModule,
	MatBottomSheetModule,
	MatButtonToggleModule,
	MatGridListModule,
	MatListModule,
	MatTooltipModule,
	MatTableModule,
	MatTabsModule,
	MatDividerModule,
	MatToolbarModule,
	MatStepperModule,
	MatSnackBarModule,
	MatSidenavModule,
	MatSortModule,
	MatPaginatorModule,
	MatSliderModule,
	MatAutocompleteModule,
	MatNativeDateModule,
	MatFormFieldModule,
	MatButtonModule,
	MatCardModule,
	MatChipsModule,
	MatProgressBarModule,
} from "@angular/material";
import { MaterialPreviewModule } from "../../partials/content/general/material-preview/material-preview.module";
import { SharedModule } from "../../../shared/shared-components/shared.module";
import { ProfileService } from "./services/profile.service";
import { PersonalDetailsService } from "./components/personal-details/personal-details.service";
import { ContactDetailsService } from "./components/contact-details/contact-details.service";
import { InternationalPhoneNumberModule } from "ngx-international-phone-number";
import { EducationDetailsService } from "./components/education-details/education-details.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ChangePasswordComponent } from "./components/change-password/change-password.component";
import { ChangeEmailComponent } from "./components/change-email/change-email.component";
import { ChangePhonenumberComponent } from "./components/change-phonenumber/change-phonenumber.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { EmpDetailsComponent } from "./components/emp-details/emp-details.component";
import { ContactInformationComponent } from "./components/contact-information/contact-information.component";
@NgModule({
	imports: [
		CommonModule,
		NgbModule,
		FormsModule,
		PartialsModule,
		InternationalPhoneNumberModule,
		BsDropdownModule.forRoot(),
		NgxIntlTelInputModule,
		InternationalPhoneNumberModule,
		SharedModule,
		RouterModule.forChild([
			{
				path: "",
				component: ProfileComponent,
			},
		]),
	],
	declarations: [
		ProfileComponent,
		PersonalDetailsComponent,
		EducationDetailsComponent,
		ContactDetailsComponent,
		ChangePasswordComponent,
		ChangeEmailComponent,
		ChangePhonenumberComponent,
		EmpDetailsComponent,
		ContactInformationComponent,
	],
	providers: [
		ProfileService,
		ContactDetailsService,
		PersonalDetailsService,
		EducationDetailsService,
	],
})
export class ProfileModule {}
